import { Card, CardActions, CardContent, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Form from './form';
import { noop } from 'shell/utils/noop';
import { DateTime } from 'luxon';

const validationSchema = yup.object({
  register: yup.string().nullable().required('Campo obbligatorio'),
  practice: yup.string().nullable().required('Campo obbligatorio'),
  operation: yup.string().nullable().required('Campo obbligatorio'),
  state: yup.string().nullable().required('Campo obbligatorio'),
  validityFrom: yup.date().typeError('Data non valida').nullable().required('Campo obbligatorio'),
  validityTo: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .required('Campo obbligatorio')
    .when('dateFrom', (dateFrom, formvalidationSchema) =>
      dateFrom
        ? formvalidationSchema.min(dateFrom, 'La data deve essere maggiore uguale della data Dal')
        : formvalidationSchema.nullable()
    ),
  hoursMax: yup.number().nullable().required('Campo obbligatorio'),
  hoursWarning: yup.number().nullable().required('Campo obbligatorio'),
});

export interface FormMetricVM {
  register?: string;
  practice?: string;
  operation?: string;
  state?: string;
  validityFrom?: DateTime | null;
  validityTo?: DateTime | null;
  hoursMax?: number;
  hoursWarning?: number;
}

interface FormMetricProps {
  disabled?: boolean;
  title: string;
  isEdit?: boolean;
  onCancel: () => void;
  initialValues?: FormMetricVM;
  onSubmit: (values: FormMetricVM) => void;
}

const FormMetricComponent = ({
  disabled,
  title,
  onCancel,
  isEdit,
  initialValues,
  onSubmit,
}: FormMetricProps): ReactElement => {
  const form = useFormik<FormMetricVM>({
    initialValues: initialValues || {
      register: undefined,
      practice: undefined,
      operation: undefined,
      state: undefined,
      validityFrom: null,
      validityTo: null,
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit || noop,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={form.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Form
              values={form.values}
              onChange={form.setFieldValue}
              disabled={disabled}
              touched={form.touched}
              errors={form.errors}
              isEdit={isEdit}
            />
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormMetricComponent.displayName = 'Form Metric Page component';

const FormMetric = memo(FormMetricComponent);

export default FormMetric;
